import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import PropTypes from 'prop-types';

import qs from 'qs';
import { delay, getErrorMessage } from '../../../../../utils/helper';
import { updateOrderRemainsUrl } from '../../../../../services/endpoints/orders';

import AlertComponent from '../../../../../components/Alert';
import Loader from '../../../../../components/Loaders/Loader';

const UpdateRemainsModal = ({ data, onHide, onSubmit }) => {
  const inputRef = useRef(null);

  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({
    init: false,
    success: false,
    form: {
      remains: '',
    },
  })
  const { form, success } = modalData;

  const queryParams = qs.parse(window.location.search.slice(1));

  const onChangeRemains = (value) => {
    setModalData((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        remains: value,
      },
    }))
  }

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await updateOrderRemainsUrl(data.id, form.remains, queryParams);
      setModalData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit(response.data)
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (inputRef?.current?.focus) {
      inputRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <form onSubmit={onSubmitForm}>
      <Modal.Header closeButton>
        <Modal.Title>Update remains</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? <Loader success={success} /> : null}
        {error ? <AlertComponent text={error} type="danger" /> : null}
        <FormGroup>
          <ControlLabel>Remains</ControlLabel>
          <FormControl
            required
            inputRef={(node) => (inputRef.current = node)}
            autoComplete="off"
            disabled={isLoading}
            autoFocus
            type="number"
            id="remains"
            name="remains"
            value={form.remains}
            onChange={(e) => onChangeRemains(e.target.value)}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button
          disabled={isLoading}
          bsStyle="primary"
          type="submit"
        >
          Update remains
        </Button>
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </form>
  );
};

UpdateRemainsModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default UpdateRemainsModal;
